import { baseResourceOptions } from './utils';
import createCollectionResource from '../shared/createResource';
import emptyObserverCreator from '../shared/emptyObserverCreator';
import SidekickModuleSpec from 'src/models/Sidekick/SidekickModuleSpec';

const sidekickModuleSpecsResource = createCollectionResource<SidekickModuleSpec>({
  name: 'sidekickModuleSpecs',
  endpoint: 'v1/orgs/:orgId/sidekick-dashboard/customers/:customerId/flows-next/module-specs',
  type: SidekickModuleSpec,
  observerCreator: emptyObserverCreator,
  options: baseResourceOptions,
});

export default sidekickModuleSpecsResource;
